import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IUpdateFn, IGetPutRequest, ITrainingPersonRequirements, ITrainingPersonRequirementsAddUpsert } from '../../interfaces'

const getSelectTrainingPersonRequirementsMutationRequest: IGetPutRequest = () => {
  return {
    method: 'put',
    url: `${config.baseUrl}/PersonTrainingRequirements/person/`,
  }
}

const useSelectTrainingPersonRequirementsMutation: IUseUpdateMutation<ITrainingPersonRequirements, ITrainingPersonRequirementsAddUpsert> = (params, options = {}) => {
  const request = useMemo(() => getSelectTrainingPersonRequirementsMutationRequest(params), [params])

  const selectTraining: IUpdateFn<ITrainingPersonRequirementsAddUpsert, ITrainingPersonRequirements> = useCallback(
    async data => {
      return axios({
        ...request,
        url: request.url + data.personId + '/sync',
        data: data.trainingTypeIds
      }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingPersonRequirements, Error, any>({
    mutationFn: selectTraining,
    ...options,
  })

  return response
}

export default useSelectTrainingPersonRequirementsMutation
